<template>
  <svg
    width="41"
    height="39"
    viewBox="0 0 41 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.6748 13.733L27.3838 11.9537L21.8894 0.85833C21.7394 0.554545 21.4925 0.308624 21.1875 0.159143C20.4226 -0.216971 19.4932 0.0964575 19.1108 0.85833L13.6164 11.9537L1.32536 13.733C0.986497 13.7812 0.67668 13.9404 0.439477 14.1815C0.152711 14.475 -0.00531001 14.87 0.000136251 15.2796C0.00558251 15.6892 0.17405 16.0799 0.468522 16.3658L9.36123 25.002L7.26028 37.1968C7.21101 37.4804 7.24253 37.7722 7.35125 38.0389C7.45997 38.3057 7.64156 38.5367 7.87541 38.7059C8.10925 38.8751 8.38601 38.9756 8.6743 38.9961C8.96259 39.0166 9.25087 38.9562 9.50645 38.8218L20.5001 33.0643L31.4937 38.8218C31.7939 38.9809 32.1424 39.0339 32.4764 38.9761C33.3188 38.8314 33.8851 38.0358 33.7399 37.1968L31.639 25.002L40.5317 16.3658C40.7737 16.1295 40.9335 15.8209 40.9819 15.4834C41.1126 14.6395 40.522 13.8584 39.6748 13.733Z"
      fill="url(#paint0_linear_1_47367)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_47367"
        x1="0.730137"
        y1="60.6273"
        x2="40.3973"
        y2="63.5105"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCCE6E" />
        <stop offset="1" stop-color="#FAC328" />
      </linearGradient>
    </defs>
  </svg>
</template>
